const jspck = require("../shim/jspck.js");
if (window.skinfx) {
  module.exports = jspck.unpack(window.skinfx);
} else {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", "skins.jspck?v=AD9yU", false);
  xhr.send(null);
  if (xhr.status === 200) {
    let v6004 = jspck.unpack(xhr.responseText);
    module.exports = v6004;
  }
}
// module.exports = require("../../skins.json");